import { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ProtectedRoute } from '../ProtectedRoute/ProtectedRoute';
import { AdminPage } from '../AdminPage/AdminPage';
import { HomePage } from '../HomePage/HomePage';
import { LoginPage } from '../LoginPage/LoginPage';
import { LogoutPage } from '../LogoutPage/LogoutPage';
import { RegistrationPage } from '../RegistrationPage/RegistrationPage';
import { InvitationPage } from '../InvitationPage/InvitationPage';
import { ForgotPasswordPage } from '../ForgotPasswordPage/ForgotPasswordPage';
import { ChangePasswordPage } from '../ChangePasswordPage/ChangePasswordPage';
import { VerifySession } from '../../actions/auth.actions';
import './App.less';

export const App: React.FC = () => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(VerifySession());
	}, [dispatch]);

	return (
		<div className='app'>
			<Switch>
				<ProtectedRoute exact path='/' component={HomePage} />
				<ProtectedRoute path='/admin' adminOnly={true} component={AdminPage} />
				<ProtectedRoute path='/invitation' component={InvitationPage} />
				<ProtectedRoute path='/changepassword' component={ChangePasswordPage} />
				<Route path='/forgotpassword' component={ForgotPasswordPage} />
				<Route path='/login' component={LoginPage} />
				<Route path='/register' component={RegistrationPage} />
				<Route path='/logout' component={LogoutPage} />
			</Switch>
		</div>
	);
};

export default App;
